export enum ProductOptions {
  Settings = "Settings",
  Gateway = "Gateway",
}